import _ from "csi/_base/underscore";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Renderer from "csi/heading/Renderer";
import html from "csi/html";
import declare from "dojo/_base/declare";
import domClass from "dojo/dom-class";

const BG_LISTED = "csi-bg-yellow";
const BG_PERMITTED = "csi-bg-green";
const BG_PROHIBITED = "csi-bg-red";

const LISTED_VALUE = "LISTED";
const PERMITTED_VALUE = "PERMITTED";
const PROHIBITED_VALUE = "PROHIBITED";

const CountriesResultIndicatorRenderer = declare(Renderer, {
	/**
	 * @override
	 * Renders a country's result value/background color depending on its result indicator value
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement): boolean {
		const currentNode = ctx.getNode();
		const parentNode = ctx.getParent();

		const currentNodeName = currentNode?.$Name;
		const countriesResultIndicators = parentNode?.CountriesResultIndicators;

		if (currentNodeName != null && !_.isEmpty(countriesResultIndicators) && currentNodeName in countriesResultIndicators) {
			const resultIndicatorValue = countriesResultIndicators[currentNodeName];

			if (new RegExp(`\\b${PROHIBITED_VALUE}\\b`, "i").test(resultIndicatorValue)) {
				domClass.add(refNode, BG_PROHIBITED);
				html.text(refNode, PROHIBITED_VALUE);
			} else if (new RegExp(`\\b${PERMITTED_VALUE}\\b`, "i").test(resultIndicatorValue)) {
				domClass.add(refNode, BG_PERMITTED);
				html.text(refNode, PERMITTED_VALUE);
			} else if (new RegExp(`\\b${LISTED_VALUE}\\b`, "i").test(resultIndicatorValue)) {
				domClass.add(refNode, BG_LISTED);
				html.text(refNode, LISTED_VALUE);
			}
		}

		return true;
	},
});

export = CountriesResultIndicatorRenderer;
